/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const QuizMinimumQuestionsForDropdownSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('QUIZ_MINIMUM_QUESTIONS_FOR_DROPDOWN')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class QuizMinimumQuestionsForDropdownSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return QuizMinimumQuestionsForDropdownSettingParser.decode(input).map(res => new QuizMinimumQuestionsForDropdownSetting(res));
    }
    static unsafeDecode(input) {
        return QuizMinimumQuestionsForDropdownSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return QuizMinimumQuestionsForDropdownSettingParser.encode(data);
    }
    static schema() {
        return QuizMinimumQuestionsForDropdownSettingParser.schema();
    }
}
